import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 20,
  flexGrow: 1,

  [theme.down("lg")]: {
    width: "100%",
  },
}));

export const ShowMoreButtonBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  ...theme.paddings(15),
}));

export const ShowMoreButton = styled("button")(({ theme }) => ({
  ...theme.paddings(5, 10),
  width: 200,
  height: 48,
  color: theme.palette.white,
  backgroundColor: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: 8,
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.3s ease-out",

  "&:hover": {
    backgroundColor: theme.palette.hoverButtonBg,
    border: `1px solid ${theme.palette.primary.dark}`,
  },
}));
